export const PORTAL_WRAPPER_ID = "portals";